import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_96lk8mhfjw: FaireBrandEntity = {
  token: "b_96lk8mhfjw",
  type: "brand",
  name: "Andy & Evan",
  avatarUrl:
    "https://cdn.faire.com/fastly/fc3722be6b34d68a9825bdbe1d2d4f62d33c81c5bb67f6bb8b8d4ddb7cf50aa4.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/05e12e1a132b940ef33a79453d1a05ea224c36e401d5fe397b1c52e8349cf734.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/fc3722be6b34d68a9825bdbe1d2d4f62d33c81c5bb67f6bb8b8d4ddb7cf50aa4.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/05e12e1a132b940ef33a79453d1a05ea224c36e401d5fe397b1c52e8349cf734.jpeg",
  location: "New York , NY, USA",
  minimumOrderDollars: 150,
  rating: 4.8,
  reviewCount: 91,
  isTopShop: true,
  isInsider: true,
  description:
    "Andy & Evan is a childrenswear brand sold at better retailers around the globe. \n\nWhen Andy & Evan left corporate America back in 2008, they dreamed of a company that would one day change the world. While that may have been a little ambitious, and the world may not have changed entirely, the way it dresses its children certainly has.\n\nAndy and Evan searched and traveled near-and-far to learn the secrets of designing and producing high quality garments. With their new-found knowledge and a desire to change the status quo, the pair infused innovation and a fresh approach at every turn. As a result, the Andy & Evan® brand has become known for its unique voice in product design,  functionality, and wearability. These qualities have quickly earned the brand multiple awards and accolades in one of the world's oldest industries, but more importantly, the trust and approval of Moms and Dads everywhere.\n\nToday, Andy & Evan® is carried at thousands of retailers worldwide and is offered in sizes newborn through seven for both boys & girls (and up to fourteen in select categories). The company is still headquartered in New York City where it was originally founded, and is run by a team of dedicated individuals all married to the cause of never accepting the status quo. As a philosophy, the company respects and cherishes its customers and retail partners, and believes-in (and stands-behind) every garment produced.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:02.902Z",
    importedBy: "entity-db-cli",
  },
};
